import { render, staticRenderFns } from "./CollectiblesMobile.vue?vue&type=template&id=910ac532"
import script from "./CollectiblesMobile.vue?vue&type=script&lang=js"
export * from "./CollectiblesMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports